import React, { useState, useEffect } from "react";
import { Container, Grid } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import {
  CustomTitle,
  CustomLabel,
} from "../../components/Custom/CustomTypography";
import ListGenericCard from "../../components/Custom/ListGenericCard";
import CustomTabs from "../../components/Custom/CustomTabs"; // Import the CustomTabs component

export default function MyLoans() {
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const searchQuery = "";
  const [proposalsAccepted, setProposalsAccepted] = useState([]);
  const [proposalsRejected, setProposalsRejected] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const fetchBorrowerList = async (searchQuery) => {
    try {
      const params = { search: searchQuery };
      const response = await api.get("/lending/my-loans/", {
        params: params,
      });
      // Set proposals into accepted and rejected based on their status
      segregateProposals(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Borrower list:", error);
      setLoading(false);
    }
  };

  const segregateProposals = (proposals) => {
    const accepted = proposals.filter(
      (proposal) => proposal.borrower_status === "approved"
    );
    const rejected = proposals.filter(
      (proposal) => proposal.borrower_status !== "approved"
    );
    setProposalsAccepted(accepted);
    setProposalsRejected(rejected);
  };

  useEffect(() => {
    fetchBorrowerList(searchQuery);
  }, [searchQuery]);

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          <CustomTitle>{t("My Loans")}</CustomTitle>
          <CustomTabs
            numTabs={2}
            tabTitles={[t("Accepted"), t("Rejected")]}
            counts={[proposalsAccepted.length, proposalsRejected.length]}
            onTabChange={setActiveTab}
            textColors={["black", "black"]}
          />
          {activeTab === 0 ? (
            <>
              {proposalsAccepted && proposalsAccepted.length !== 0 ? (
                <Grid container>
                  <div
                    style={{
                      height: "93%",
                      width: "100%",
                      overflowY: "scroll",
                      marginTop: "10px",
                    }}
                  >
                    {proposalsAccepted.map((proposal) => (
                      <div key={proposal.id} style={{ width: "99%" }}>
                        <ListGenericCard
                          title={`${proposal?.target_user?.first_name} ${proposal?.target_user?.last_name}`}
                          subtitle={[
                            `${proposal.amount}`,
                            `${proposal.loan_type}`,
                            `${proposal.borrower_status}`,
                          ]}
                          // onClick={() =>
                          //   handleCardClick(
                          //     proposal?.submit_user?.id,
                          //     proposal.id
                          //   )
                          // }
                        />
                      </div>
                    ))}
                  </div>
                </Grid>
              ) : (
                <div>
                  <CustomLabel>{t("No Accepted Data Found")}</CustomLabel>
                </div>
              )}
            </>
          ) : (
            <>
              {proposalsRejected && proposalsRejected.length !== 0 ? (
                <Grid container>
                  <div
                    style={{
                      height: "93%",
                      width: "100%",
                      overflowY: "scroll",
                      marginTop: "10px",
                    }}
                  >
                    {proposalsRejected.map((proposal) => (
                      <div key={proposal.id} style={{ width: "99%" }}>
                        <ListGenericCard
                          title={`${proposal?.target_user?.first_name} ${proposal?.target_user?.last_name}`}
                          subtitle={[
                            `${proposal.amount}`,
                            `${proposal.loan_type}`,
                            `${proposal.borrower_status}`,
                          ]}
                          // onClick={() =>
                          //   handleCardClick(
                          //     proposal?.submit_user?.id,
                          //     proposal.id
                          //   )
                          // }
                        />
                      </div>
                    ))}
                  </div>
                </Grid>
              ) : (
                <div>
                  <CustomLabel>{t("No Rejected Data Found")}</CustomLabel>
                </div>
              )}
            </>
          )}
        </Container>
      </LoaderContainer>
    </>
  );
}
